const state = {
  currentEmployee: {},
  authenticated: false,
  classRoom: null,
  navigation: null,
  teacher: null,
}

const mutations = {
  CLASS_ROOM(state, payload) {
    state.classRoom = payload
  },
  RESET_CLASS_ROOM(state) {
    state.classRoom = null
  },
  NAVIGATION(state, payload) {
    state.navigation = payload
  },
  TEACHER(state, payload) {
    state.teacher = payload
  },
}

const actions = {
  resetClassRoom({
    commit
  }) {
    commit('RESET_CLASS_ROOM')
  },
  setClassRoom({
    commit
  }, payload) {
    commit('CLASS_ROOM', payload)
  },
  setNavigation({
    commit
  }, payload) {
    commit('NAVIGATION', payload)
  },
  setTeacher({
    commit
  }, payload) {
    commit('TEACHER', payload)
  },
}

const getters = {
  getClassRoom(state) {
    return state.classRoom
  },
  getNavigation(state) {
    return state.navigation
  },
  getTeacherStore(state) {
    return state.teacher
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}